import {
    ConfigNodeViewConfig
} from "../../../../../../core/shared/components/mvs-config-node-view/data/config-node-view.interfaces";

/**
 * Node View Configuration for te.TeTemplateBlueprint entity
 *
 * Entity: te.TeTemplateBlueprint
 *
 * Direct Children (Navigation Items):
 * - te.TeTemplateBlueprintVariable (variables) - FK: blueprint
 * - te.TeTemplateBlueprintArtefact (artefacts) - FK: blueprint
 *
 * Terminal Relationships (Nested):
 * - te.TeTemplateBlueprintArtefact → te.TeTemplateBlueprintArtefactVariableLink (variableLinks)
 */
export const TE_BLUEPRINT_NODE_VIEW_CONFIG: ConfigNodeViewConfig = {
    root: {
        entityType: 'te.TeTemplateBlueprint',
        badgeLabel: 'BLUEPRINT',
        defaultIcon: 'fa-regular fa-blueprint'
    },
    navigationItems: [
        {
            id: 'variables',
            label: 'Variablen',
            icon: 'fa-solid fa-brackets-curly',
            entityType: 'te.TeTemplateBlueprintVariable',
            foreignKey: 'blueprint',
            canAdd: true,
            canEdit: true,
            displayField: 'name'
        },
        {
            id: 'artefacts',
            label: 'Artefakte',
            icon: 'fa-solid fa-file-code',
            entityType: 'te.TeTemplateBlueprintArtefact',
            foreignKey: 'blueprint',
            canAdd: true,
            canEdit: true,
            displayField: 'name'
        }
    ],
    terminalRelationships: {
        'te.TeTemplateBlueprintVariable': [],
        'te.TeTemplateBlueprintArtefact': [
            {
                id: 'variableLinks',
                label: 'Variable Links',
                icon: 'fa-solid fa-link',
                entityType: 'te.TeTemplateBlueprintArtefactVariableLink',
                foreignKey: 'blueprintArtefact',
                canAdd: true,
                canEdit: true,
                displayField: '$parent'
            }
        ]
    },
    displayOptions: {
        expandLabel: 'AUSKLAPPEN',
        collapseLabel: 'EINKLAPPEN',
        entriesLabel: 'Einträge',
        relationsLabel: 'Relationen',
        showMoreLabel: 'weitere anzeigen',
        showLessLabel: 'Weniger anzeigen',
        noResultsLabel: 'Keine Einträge gefunden',
        searchPlaceholder: 'Suchen...',
        newestLabel: 'Neueste',
        oldestLabel: 'Älteste'
    }
};
